export default "/assets/site/images/katalin_agnes.png?49076171ee52d1792aa63e7881e2d2ec";